import LoadingV1 from '@/components/common/LoadingV1'
import NoResult from '@/components/no-result'
/* 一般列表引入加载loading及缺省页组件
 * 在vue中引入该mixins
 * 模板中添加对应html
 * 获取数据后将loading=false
 * e.g.  '../../page/my-policy'
 */
export const listLoadingResult = {
  data () {
    return {
      loading: true
    }
  },
  components: {
    LoadingV1,
    NoResult
  }
}
